import React, { ReactElement } from 'react';

import Modal from 'components/modal';

import './common-modal.scss';

import usingCredibleReviewsImage from 'assets/images/company-view/using-credible-reviews-badge.inline.svg';

interface CompanyViewBadgeModalProps {
    onClose: () => void;
}

const CompanyViewBadgeUsingCredibleReviewsModal: React.FC<CompanyViewBadgeModalProps> = ({ onClose }): ReactElement => (
    <Modal
        showCloseIcon={true}
        center={true}
        isOpen={true}
        onClose={onClose}
        shouldCloseOnOverlayClick={true}
        modalClassName="rating-modal"
        useModalLayout={true}
        title="System Wiarygodnych Opinii"
    >
        <div className="badge-modal badge-modal--using-credible-reviews">
            <img src={usingCredibleReviewsImage} alt="Ten sklep ma wdrożony System Wiarygodnych Opinii" className="badge-modal__img"/>
            <div className="badge-modal__header">
                <br/>
                {''}
                Ten sklep ma wdrożony System Wiarygodnych Opinii.
            </div>
            <p className="badge-modal__paragraph">
                Wiarygodne Opinie to opinie wystawione po dokonaniu transakcji, wyrażone za pomocą formularza serwisu
                - po zaproszeniu wygenerowanym przez system Wiarygodnych Opinii.
            </p>
        </div>
    </Modal>
);

export default CompanyViewBadgeUsingCredibleReviewsModal;
